import type { FaqSectionContent } from "@site-factory/config";
import { BandedSection, type BandedSectionVariant } from "../components/BandedSection";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/Accordion";
import { SectionTitle, SectionSubtitle } from "../typography/Typography";

export interface FaqSectionProps extends FaqSectionContent {
  className?: string;
  bandVariant?: BandedSectionVariant;
}

export function FaqSection({
  title,
  subtitle,
  items,
  variant = "accordion",
  className,
  bandVariant = "sky",
}: FaqSectionProps) {
  return (
    <BandedSection variant={bandVariant} className="py-16 md:py-24" contentClassName={className}>
      {(title || subtitle) && (
        <div className="text-center mb-12">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle className="mt-4">{subtitle}</SectionSubtitle>}
        </div>
      )}

      <div className="max-w-3xl mx-auto">
        {variant === "accordion" ? (
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-[var(--color-surface,#fff)] text-[var(--color-text,#0f172a)] border border-[color:var(--color-text,#0f172a)]/12 rounded-xl"
              >
                <AccordionTrigger>{item.question}</AccordionTrigger>
                <AccordionContent>
                  <span>{item.answer}</span>
                  {item.answerLink && (
                    <>
                      {" "}
                      <a href={item.answerLink.href} className="text-primary font-semibold hover:underline">
                        {item.answerLink.label}
                      </a>
                    </>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        ) : (
          <div className="space-y-8">
            {items.map((item, index) => (
              <div
                key={index}
                className="p-4 rounded-[12px] bg-[var(--color-surface,#fff)] text-[var(--color-text,#0f172a)] border border-[color:var(--color-text,#0f172a)]/12 shadow-sm"
              >
                <h3 className="text-lg font-semibold mb-2">{item.question}</h3>
                <p style={{ color: "var(--color-text,#0f172a)", opacity: 0.82 }}>
                  {item.answer}{" "}
                  {item.answerLink && (
                    <a href={item.answerLink.href} className="text-primary font-semibold hover:underline">
                      {item.answerLink.label}
                    </a>
                  )}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </BandedSection>
  );
}
